module.exports = __webpack_public_path__ + "static/media/icn_mainnav_journeys.2ae1e8c6.svg";